import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store/store";

/**
 * Custom hook to manage all Redux selectors needed for filter generation
 * Separates selector logic from business logic for better testability
 */
export const useFilterDataSelectors = () => {
  const {
    data: algoliaMultiFacetsCount,
    loading: algoliaMultiFacetsCountLoading,
  } = useSelector((state: RootState) => state.algoliaMultiFacetsCount);

  const { data: authStatusOptions } = useSelector(
    (state: RootState) => state.authStatusOptions,
  );

  const { data: boOptions } = useSelector(
    (state: RootState) => state.boOptions,
  );

  const { data: providerDetails } = useSelector(
    (state: RootState) => state.providerDetails,
  );

  const { data: allProvidersDetails } = useSelector(
    (state: RootState) => state.allProviders,
  );

  return {
    algoliaMultiFacetsCount,
    algoliaMultiFacetsCountLoading,
    authStatusOptions,
    boOptions,
    providerDetails,
    allProvidersDetails,
  };
};
